const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

export const careerApiRepository = {
    getCareers: async () => {
        const res = await fetch(`${API_BASE_URL}/api/careers`);
        if (!res.ok) throw new Error('채용 공고 조회에 실패했습니다.');
        return res.json();
    },

    getCareerById: async (id) => {
        const res = await fetch(`${API_BASE_URL}/api/careers/${id}`);
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.message || '채용 공고를 찾을 수 없습니다.');
        }
        return res.json();
    },

    applyCareer: async (id, formData, accessToken) => {
        const headers = {};
        if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

        const res = await fetch(`${API_BASE_URL}/api/careers/${id}/apply`, {
            method: 'POST',
            headers,
            body: formData,
        });
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.message || '지원서 제출에 실패했습니다.');
        }
    },
};
